<template>
<div class="page-container" v-loading="isLoading"> 
  <div class="search-box">
    <div class="flex-row search-main">
      <el-popover
        popper-class="search-popover"
        placement="bottom"
        width="628"
        v-model="showSearchPopover"
        trigger="click">
        <div class="history-popup">
          <!-- <div class="search-popver__title">大家都在搜</div>
          <div class="search-popver__content">
            <div class="item" v-for="(item, index) in tags" @click="selectTag(item)" :key="index">{{ item }}</div>
          </div> -->
          <div class="search-popver__title">
            <span>搜索历史</span>
            <span class="clear-btn" v-if="historyList.length" @click="clearHistoryDialog = true"><i class="el-icon-delete"></i>清除</span>
          </div>
          <div :class="['search-popver__content', 'history-content', historyExpanded ? 'is-expanded' : '']" v-if="historyList.length" ref="historyContent">
            <div class="history-items" ref="historyItems">
              <div class="item" v-for="(item, index) in historyList" @click="historyItemClick(item)" :key="index">{{ item }}</div>
            </div>
            <div class="expand-btn" v-if="historyOverflow && !historyExpanded" @click="historyExpanded = true"><i class="el-icon-arrow-down"></i></div>
            <div class="expand-btn" v-if="historyExpanded" @click="historyExpanded = false"><i class="el-icon-arrow-up"></i></div>
          </div>
          <div class="search-popver__content" v-else>
            <div class="no-data" style="padding: 0; font-size: 12px;">暂无搜索历史</div>
          </div>
        </div>
        <div class="input-btn flex-row" slot="reference">
          <el-input style="width: 600px;" placeholder="请输入品类/品牌/机制/商品名称/报单ID" v-model="keyword" />
          <el-button class="search-btn" @click="toSearch()">搜索</el-button>
        </div>
      </el-popover>
    </div>
    <!-- <div class="tags-box">
      <span class="tag" v-for="tag in tags" :key="tag" @click="selectTag(tag)">{{ tag }}</span>
    </div> -->
  </div>

  <div class="cards-container" v-if="list.length && !isLoading">
    <div class="item" v-for="(item, index) in list" :key="index">
      <ProductCard :product="item" :roleType="roleType" @toReserve="toReserve(item)" />
    </div>
  </div>
  <div v-else class="no-data">
    暂无数据
  </div>
  <div class="page-pagination">
    <el-pagination
      v-if="pageInfo.total > 0"
      class="d-ib"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
      :page-size="pageInfo.pageSize"
      :page-sizes="pageInfo.sizes"
      :current-page="pageInfo.pageIndex"
      @current-change="pageInfo.pageIndex = arguments[ 0 ], getList()"
      @size-change="pageInfo.pageSize = arguments[ 0 ]; pageInfo.pageIndex = 1; getList()">
    </el-pagination>
  </div>

  <!-- 下载提示框 -->
  <BaseDailog v-if="showXlsxDialog" v-model="showXlsxDialog" width="512px" :showCancel="false" @confirm="copyLink"
    title="下载最新口令表格"
    confirmText="点击复制"
    :subTitle="`下载时间：${xlsxInfo.time}`"
  >
    <div class="download-container">
      <div class="down-tip">请复制以下链接，使用浏览器打开，<span class="red">并在10分钟内下载</span>，逾期将自动失效（内部资料，<span class="red">请勿外传，一经发现，终止合作</span>)</div>
      <div>
        <div class="down-title">下载链接：</div>
        <a :href="xlsxInfo.url" target="_blank">{{ xlsxInfo.url }}</a>
      </div>
    </div>
  </BaseDailog>

  <BaseDailog v-if="showCopyDialog" v-model="showCopyDialog" width="512px" :showCancel="false" @confirm="copyKLFn"
    title="复制口令"
    confirmText="点击复制"
    sourceType="sup"
  >
    <div v-if="curRow" class="copy-content">
      <div>直播间：{{ curRow.liveRoomName }}</div>
      <div>品类：{{ curRow.categoryName }}</div>
      <div>品牌：{{ curRow.brandName }}</div>
      <div v-if="curRow.h5Show == 1 && curRow.signalPass && curRow.backendCommission">
        <div>失效时间：{{ computedTime(curRow.activityEndTime) }}</div>
        <div>口令：{{ extractUrls(curRow.signalPass) }}</div>
        <div>爆品补佣金：{{ curRow.userCommissionRate || 0}}%</div>
        <div>爆品补折扣：{{ curRow.userRebateStr || 0 }}折</div> 
      </div>
      <div v-else style="margin-top: 20px;">
        选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！
      </div>
    </div>
  </BaseDailog>

  <BaseDailog v-if="clearHistoryDialog" v-model="clearHistoryDialog" width="512px" @cancel="showSearchPopover = true; clearHistoryDialog = false;" sourceType="sup" @confirm="clearHistory" title="提示">
    <div class="clear-content">确定要删除所有历史记录吗？</div>
  </BaseDailog>

  <BuyDrawer v-model="showBuyDrawer" @toOrder="toOrder(curRow)" :product="curRow" />

  <OrderReserveDrawer v-model="showOrderReserveDrawer" :product="curRow" @success="getList" />

  <AddReportDialog
    v-if="showAddReportDialog"
    v-model="showAddReportDialog"
    :roleType="roleType"
    :product="curRow"
    @check-result="checkResultCb"
    @close="showAddReportDialog = false"
    @on-success="showAddResultDialogHandler"
  />

  <!-- 检查结果弹框 -->
  <CheckResultDialog
    v-if="showCheckResultDialog"
    v-model="showCheckResultDialog"
    :rst="checkResult"
    @close="showCheckResultDialog = false" />

  <AddResultDialog
    v-if="showAddResultDialog"
    v-model="showAddResultDialog"
    :importResult="importResult"
    :roleType="roleType"
    @close="showAddResultDialog = false; importResult = {}"
    @on-success="showAddResultDialog = false"
  />

  <WbotIcon />
</div>
</template>

<script>
import BaseDailog from '@/page/component/sections/base-dailog'
import ProductCard from '@/page/component/sections/xpk/sup/product-card'
import BuyDrawer from '@/page/component/sections/xpk/sup/buy-drawer'
import OrderReserveDrawer from '@/page/component/sections/xpk/sup/order-reserve-drawer'
import AddReportDialog from '@/page/component/sections/order/sup-add-report-dialog.vue'
import CheckResultDialog from '@/page/component/sections/order/check-result-dialog.vue'
import AddResultDialog from '@/page/component/sections/order/sup-add-result-dialog.vue'
import WbotIcon from '@/page/component/sections/xpk/wbot-icon.vue'
import { getUserId } from '@/utils/getUser'
import { getAccountRoleType } from '@/service/apis/order'
import {
  getKlHotSearchWord
} from '@/service/apis/kl'
import { getQdVolumeProductList } from '@/service/apis/supVolume'
import { addBuryingPoint } from '@/service/apis/common'
import moment from 'moment'
import { copyFn } from '@/utils/util'

export default {
  components: {
    BaseDailog,
    ProductCard,
    BuyDrawer,
    OrderReserveDrawer,
    AddReportDialog,
    CheckResultDialog,
    AddResultDialog,
    WbotIcon
  },
  name: 'XpkM2s',
  data() {
    return {
      showSearchPopover: false,
      historyList: [],
      clearHistoryDialog: false,
      historyExpanded: false,
      historyOverflow: false,
      keyword: '',
      hasData: true,
      tags: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 20,
        sizes: [ 10, 20, 30, 50, 100 ],
        total: 0
      },
      list: [],
      isLoading: false,
      curRow: null,
      showCopyDialog: false,
      showBuyDrawer: false,
      showOrderReserveDrawer: false,
      showAddReportDialog: false,
      roleType: null,
      checkResult: null,
      showCheckResultDialog: false,
      showQueryBdRebateInfoDialog: false,
      showAddResultDialog: false
    }
  },
  watch: {
    showSearchPopover (val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => this.checkHistoryOverflow(), 50)
        })
      }
    }
  },
  async created () {
    await this.getAccountRoleType()
    this.init()
    this.getList()
  },
  methods: {
    getAccountRoleType () {
      const accountId = getUserId()
      getAccountRoleType.call(this, {
        accountId // getUserId()
      }).then(res => {
        if (res) {
          this.roleType = res 
        }
      })
    },
    clearHistory () {
      this.historyList = []
      window.localStorage.setItem('SUP_HISTORY_SEARCH', JSON.stringify(this.historyList))
    
      this.clearHistoryDialog = false
    },
    historyItemClick (tag) {
      this.updateHistoryList(tag)
      this.toSearchPage(tag)
    },
    updateHistoryList (tag) {
      if (this.historyList.includes(tag)) {
        this.historyList = this.historyList.filter(item => item !== tag)
      }
      this.historyList.unshift(tag)
      window.localStorage.setItem('SUP_HISTORY_SEARCH', JSON.stringify(this.historyList))
      this.$nextTick(() => this.checkHistoryOverflow())
    },
    checkHistoryOverflow () {
      const el = this.$refs.historyItems
      if (el) {
        this.historyOverflow = el.scrollHeight > 76
      }
    },
    isValid (data) {
      if (data.h5Show == 0 || (!data.signalPass && !data.backendCommission)) { 
        return false
      }
      if (data.validEndTime) {
        const now = moment()
        const validEndTime = moment(data.validEndTime)
        return now.isBefore(validEndTime)
      }
      return false
    },
    copyKLFn () {
      const data = this.curRow || {}
      let copyContent = ''
      copyContent = this.isValid(data) ? `直播间：${data.liveRoomName}\n品类：${data.categoryName}\n品牌：${ data.brandName }\n失效时间：${ computedTime(data.validEndTime) }\n口令：${ extractUrls(data.signalPass) }\n爆品补佣金：${ data.userCommissionRate || 0 }%\n补贴后折扣：${ data.userRebateStr || 0 }折` 
        : `直播间：${data.liveRoomName}\n品类：${data.categoryName}品牌：${ data.brandName }\n选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！`
    
      copyFn(copyContent, () => {
        this.showCopyDialog = false
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
      addBuryingPoint.call(this, {
        type: 2,
        liveRoomId: data.liveRoomId || '',
        liveRoomName: data.liveRoomName || '',
        copyContent: JSON.stringify({
          mainImage: data.mainImage,
          liveRoomName: data.liveRoomName,
          productName: data.productName,
          copyContent
        }, false, false)
      })
    },
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    checkResultCb(rst) {
      console.log('checkResult', rst)
      this.checkResult = rst
      this.showAddReportDialog = false
      this.showCheckResultDialog = true
    },

    showAddResultDialogHandler (rst) {
      this.showAddReportDialog = false
      this.importResult = rst
      this.showAddResultDialog = true
    },
    toOrder (row) {
      this.curRow = row
      this.showAddReportDialog = true
    },
    toBuy (row) {
      console.log(row)
      // this.curRow = row
      // this.showBuyDrawer = true
    },
    toReserve (row) {
      this.curRow = row
      this.showOrderReserveDrawer = true
    },
    copyContent (row) {
      this.curRow = row
      this.showCopyDialog = true
    },
    async getKlHotSearchWord () {
      const res = await getKlHotSearchWord.call(this)
      this.tags = (res || []).map(item => item.word)
    },
    copyLink () {
      const input = document.createElement('input')
      input.value = this.xlsxInfo.url
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    extractUrls (text) {
      const urlRegex = /weixin?:\/\/[^\s]+/i;
      let match = text.match(urlRegex);
      if (match) {
        return match[0].trim()
      }
      return ''
    },

    init () {
      const history = window.localStorage.getItem('SUP_HISTORY_SEARCH')
      if (history) {
        this.historyList = JSON.parse(history)
      }
      this.getKlHotSearchWord()
  
      addBuryingPoint.call(this, {
        type: 1 // 1-登录 2-复制 3-搜索 5-下载口令
      })
    },
    getList () {
      this.isLoading = true
      getQdVolumeProductList.call(this, {}).then(res => {
        const products = res || []
        const start = (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize
        this.list = products.slice(start, start + this.pageInfo.pageSize)
        this.pageInfo.total = products.length
      }).finally(() => {
        this.isLoading = false
      })
    },
    exportData() {
      // 导出逻辑
      console.log('导出数据')
    },
    selectTag(tag) {
      this.toSearchPage(tag)
      // this.getList()
    },
    toSearch () {
      if (!this.keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      this.updateHistoryList(this.keyword)
      this.toSearchPage(this.keyword)
    },
    toSearchPage (keyword) {
      if (!keyword && !this.keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      this.$router.push({
        path: '/xpk/sup/search',
        query: {
          keyword: keyword || this.keyword
        }
      })
    }
  }
}
</script>

<style scoped>
.search-main,
.tags-box {
  padding: 12px 0 0 0;
  width: 720px;
  margin: 0 auto;
}
.tags-box {
  color: #6A6A6A;
}
.tags-box .tag {
  cursor: pointer;
  font-size: 13px;
  margin-right: 12px;
}
.input-btn {
  border: solid 1px #9266FF;
  padding: 1px;
  border-radius: 4px;
}
.input-btn ::v-deep .el-input__inner {
  border: none;
}
.input-btn .search-btn {
  padding: 0 12px;
  border: 1px solid;
  color: #fff;
  background: linear-gradient(270deg, #9A63FF 0%, #FF48D3 100%); 
}
.export-btn {
  padding: 0 12px;
  border: 1px solid #9266FF;
  color: #fff;
  background-color: #9266FF;
  margin-left: 12px;
}
.search-types {
  padding: 12px;
  padding-bottom: 0;
  background-color: #fff;
}
.search-types .type-line {
  display: flex;
  flex-wrap: wrap;
  line-height: 24px;
  margin-bottom: 12px;
}
.type-line .item {
  cursor: pointer;
  margin-right: 24px;
  font-size: 13px;
  color: #000;
}
.type-line .item.active,
.type-line .item:hover {
  font-weight: 600;
  color: #9266FF;
}
.type-line2 { 
  position: relative;
  height: 24px;
  line-height: 24px;
  overflow: hidden;
  padding-right: 24px;
}
.type-line2.is-down {
  height: auto;
  overflow: hidden;
}
.type-line2 .down {
  cursor: pointer;
   position: absolute;
  top: 0px;
  right: 0px;
}
.type-line2 .item {
  margin-right: 16px;
  color: #6A6A6A;
}

.type-line2 .item.active,
.type-line2 .item:hover {
  font-weight: inherit;
  color: #9266FF;
}
.line-tabs {
  cursor: pointer;
  display: flex;
  color: rgba(0, 0, 0, 0.6);
  position: relative;
  height: 24px;
  font-size: 14px;
  font-weight: 500x;
  line-height: 24px;
}
.line-tabs::after {
  content: '';
  position: absolute; 
  bottom: 1px;
  height: 1px;
  width: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.1);
}
.line-tabs .item {
  margin-right: 24px;
  position: relative;
}
.line-tabs .item.active,
.line-tabs .item:hover {
  color: #9266FF;
}
.line-tabs .item.active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  border-radius: 3px;
  background-color: #9266FF;
  z-index: 2;
}
.cards-container {
  padding: 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.cards-container .item {
  width: calc((100% - (24px * 4)) / 5);
  margin: 0 24px 24px 0;
}
.cards-container .item:nth-child(5n) {
  margin-right: 0;
}
.page-pagination {
  text-align: center;
  padding-bottom: 24px;
}
.no-data {
  padding: 24px 0;
  text-align: center;
  font-size: 16px;
  color: #999;
}
.download-container {
  line-height: 22px;
  background-color: #fff;
}
.down-tip {
  border-bottom: solid 1px rgba(229, 229, 229, 1);
  padding-bottom: 12px;
  margin-bottom: 12px;
}
.copy-content {
  line-height: 24px;
}
.search-popver__title {
  line-height: 20px;
  color: rgba(47, 47, 47, 1);
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-popver__content {
  padding: 6px 0 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.search-popver__content .item {
  font-size: 12px;
  color: rgba(100, 100, 100, 1);
  border: solid 0.5px rgba(218, 218, 218, 1);
  line-height: 32px;
  padding: 0 12px;
  border-radius: 18px;
  margin: 0 16px 6px 0;
  cursor: pointer;
  transition: all 0.3s;
}
.search-popver__content .item:hover {
  background-color: #9266FF;
  color: #fff;
}
.clear-btn {
  color: rgba(100, 100, 100, 1);
  font-size: 12px;
  cursor: pointer;
}
.clear-btn i {
  margin-right: 3px;
}
.clear-btn:hover {
  color: #9266FF;
}
.clear-content {
  font-size: 16px;
  text-align: center;
  padding-bottom: 24px;
}
.history-content {
  position: relative;
  padding-right: 24px;
}
.history-content .history-items {
  display: flex;
  flex-wrap: wrap;
  max-height: 76px;
  overflow: hidden;
}
.history-content.is-expanded .history-items {
  max-height: none;
}
.history-content .expand-btn {
  position: absolute;
  right: 0;
  bottom: 6px;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  line-height: 32px;
}
.history-content .expand-btn:hover {
  color: #9266FF;
}
</style>
